import Logger from '../../services/Logger';

export const randomGameErrors = {
  //for randomGamePage
  noCategory: () => 'No random category was set in common configuration',
  errorOnRequest: (categoryId) =>
    `Error while requesting random games by category ${categoryId}`,
  noData: () => 'Empty data on request for random games',
  timeout: (categoryId) =>
    `Timeout error while requesting random games by category ${categoryId}`,
  //for gamePage after randomGamePage
  noGameById: () => `No game in request on GamePage`,
};

export const gameFrameEventCreator = (type, payload = {}) => ({
  type,
  ...(payload ? payload : {}),
});

export const frameMessageLogger = new Logger('FrameMessage', {
  prefixColor: '#f30606',
});
